/**
 * 售后订单
 */

import axios from '@/utils/request'

export default {
  getAfterSalesOrderList: (data) => axios({ url: '/api/orders/admin/returns', method: 'POST', data }), // 后台-获取售后单列表
  initiateProcessRefund: (returnsId, data) => axios({ url: `/api/orders/admin/returns/${returnsId}`, method: 'PUT', data }), // 后台-审批退款
  getAfterSalesOrderDetails: (returnsId, params) => axios({ url: `/api/orders/admin/returns/${returnsId}`, method: 'GET', params }), // 后台-获取售后单详情
  getOrderRefundRecord: (kkOrderId, params) => axios({ url: `/api/orders/refund/${kkOrderId}`, method: 'GET', params }), // 获取订单退款记录
  getRefundOrderInformation: (kkOrderId, params) => axios({ url: `/api/orders/refundForm/${kkOrderId}`, method: 'GET', params }), // 前后台-新建退款单页面查询
  createAfterSalesOrder: (kkOrderId, data) => axios({ url: `/api/orders/returns/${kkOrderId}`, method: 'POST', data }), // 前后台-创建售后单
  getRefundOrderAmount: (kkOrderId, data) => axios({ url: `/api/orders/refund/amount/${kkOrderId}`, method: 'POST', data }), // 前后台-退款提交金额查询
  orderUploadFile: data => axios({ url: `/api/hbo/uploadFile`, method: 'post', data }), // 上传文件阿里云文件服务器
}
